// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__wrb7Y","icon":"styles_icon__T5NvE","actions":"styles_actions__RIrQy","subtitle":"styles_subtitle__Pp0uK"};